import React from 'react'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import PropTypes from 'prop-types'

import * as mapSelectors from '../../Map/map.selectors'

const HoverComponent = ({ building, position, storyBuildings, intl }) => {
  if (!building || Object.keys(building).length == 0) {
    return null
  }
  if (!position || Object.keys(position).length == 0) {
    return null
  }

  let building_config = storyBuildings[building.name]

  return (
    <div
      className="box--border"
      style={{ position: 'absolute', top: position.y + 10, left: position.x + 10 }}
    >
      <div className="box--border__canvas">
        <ul className="list--panel submenu">
          <li className="list--panel__item">
            <span className={building_config.icon}> </span>
            <span className="text">
              <FormattedMessage id={building_config.name} />
            </span>
          </li>
          <li className="list--panel__item inline">
            <div className="panel--info">
              <div className="panel--info__item">
                <FormattedMessage
                  id="map.buildings.production"
                  title="map.buildings.bonus_explained"
                />
                <b>
                  {building.production ? building.production : building_config.productionAmount[0]}
                  <span className={building_config.icon}> </span>/{' '}
                  {building.multiplier ? building.multiplier : 1}
                  <span
                    title={intl.formatMessage({ id: 'map.buildings.bonus_explained' })}
                    className="icon-info"
                  ></span>
                </b>
              </div>
              <div className="panel--info__item">
                <FormattedMessage id="map.buildings.level" />
                <b> {building.level || 1}</b>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  storyBuildings: mapSelectors.getBuildings(state),
})

HoverComponent.propTypes = {
  building: PropTypes.object,
  position: PropTypes.object,
  storyBuildings: PropTypes.object,
}

export default connect(mapStateToProps, null)(injectIntl(HoverComponent))
